export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    couponDetailList: [
      {
        couponGroupIdx: 1,
        couponDetailIdx: 1,
        couponDetailName: "10% 쿠폰",
        discountType: "rate",
        amount: "10",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 1,
        couponDetailIdx: 2,
        couponDetailName: "10% 쿠폰2",
        discountType: "rate",
        amount: "10",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 1,
        couponDetailIdx: 3,
        couponDetailName: "VIP - 10% 쿠폰",
        discountType: "rate",
        amount: "10",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 1,
        couponDetailIdx: 4,
        couponDetailName: "RVIP - 10% 쿠폰",
        discountType: "rate",
        amount: "10",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 1,
        couponDetailIdx: 5,
        couponDetailName: "임직원 전용",
        discountType: "rate",
        amount: "10",
        cnt: 10,
        desc: "",
      },

      {
        couponGroupIdx: 2,
        couponDetailIdx: 6,
        couponDetailName: "20% 쿠폰",
        discountType: "rate",
        amount: "20",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 2,
        couponDetailIdx: 7,
        couponDetailName: "20% 쿠폰2",
        discountType: "rate",
        amount: "20",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 2,
        couponDetailIdx: 8,
        couponDetailName: "VIP - 20% 쿠폰",
        discountType: "rate",
        amount: "20",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 2,
        couponDetailIdx: 9,
        couponDetailName: "RVIP - 20% 쿠폰",
        discountType: "rate",
        amount: "20",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 2,
        couponDetailIdx: 10,
        couponDetailName: "임직원 전용",
        discountType: "rate",
        amount: "20",
        cnt: 10,
        desc: "",
      },

      {
        couponGroupIdx: 3,
        couponDetailIdx: 11,
        couponDetailName: "20% 쿠폰",
        discountType: "rate",
        amount: "20",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 3,
        couponDetailIdx: 12,
        couponDetailName: "25% 쿠폰",
        discountType: "rate",
        amount: "25",
        cnt: 10,
        desc: "",
      },
      {
        couponGroupIdx: 3,
        couponDetailIdx: 13,
        couponDetailName: "오더 첫 주문",
        discountType: "rate",
        amount: "30",
        cnt: 10,
        desc: "",
      },

      {
        couponGroupIdx: 4,
        couponDetailIdx: 14,
        couponDetailName: "무료 쿠폰",
        discountType: "rate",
        amount: "100",
        cnt: 2,
        desc: "",
      },

      {
        couponGroupIdx: 5,
        couponDetailIdx: 15,
        couponDetailName: "머그 사용",
        discountType: "fix",
        amount: "500",
        cnt: 10,
        desc: "",
      },

      {
        couponGroupIdx: 6,
        couponDetailIdx: 16,
        couponDetailName: "스탬프 무료",
        discountType: "rate",
        amount: "100",
        cnt: 10,
        desc: "",
      },
    ],
  },
};
